import React, { useRef } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { formatNumber, lineStatus } from '../../../utils';
import { makeStyles } from '@material-ui/core/styles';
import EllipsisTooltip from '../Tooltip/EllipsisTooltip';
import { useLinesContext } from '../../../contexts/Lines';
import Typography from '@material-ui/core/Typography';
import UnitsEdit from './UnitsEdit';

const useStyles = makeStyles((theme: any) => ({
  unitsText: {
    color: theme.palette.brand.greenDeep,
    fontWeight: 500,
    fontSize: 16,
    marginLeft: theme.spacing(0.5),
  },
  inventory: {
    color: theme.palette.brand.greenDark,
    fontWeight: 700,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function Units({
  line,
  setLineInfoDuringEdit,
  addOrDeleteError,
}) {
  const classes = useStyles();
  const mobile = useMobile();
  const overflowRef = useRef();
  const formattedInventory = formatNumber(line.inventory);
  const { lines } = useLinesContext();

  const completeOriginLine = lines?.find(
    (originLine) =>
      line.origin_line === originLine.id &&
      originLine.status === lineStatus.complete,
  );

  const lineEditable = line.edit && !completeOriginLine;

  return (
    <>
      {lineEditable && (
        <UnitsEdit
          line={line}
          setLineInfoDuringEdit={setLineInfoDuringEdit}
          addOrDeleteError={addOrDeleteError}
        />
      )}
      {!lineEditable && (
        <EllipsisTooltip
          arrow
          title={<Typography>{formattedInventory}</Typography>}
          placement="top"
          enterDelay={500}
          enterNextDelay={500}
          overflowElementRef={overflowRef}
        >
          <div className={classes.row}>
            <Typography
              gutterBottom={!mobile}
              className={classes.inventory}
              ref={overflowRef}
            >
              {formattedInventory}
            </Typography>
            <span className={classes.unitsText}>units</span>
          </div>
        </EllipsisTooltip>
      )}
    </>
  );
}
